import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, MapPin } from "lucide-react";
import { BRAND, NAV_LINKS } from "../lib/gomill-data";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  useEffect(() => { setOpen(false); }, [loc.pathname]);

  return (
    <>
    <header className="sticky top-0 z-50 gm-glass" data-testid="site-navbar">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 h-20 md:h-24 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2 shrink-0" data-testid="nav-logo">
          <img src={BRAND.logoFull} alt="GoMill" className="h-12 md:h-14 w-auto object-contain" />
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {NAV_LINKS.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              data-testid={`nav-link-${link.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
              className={({ isActive }) =>
                `px-3 py-2 text-sm font-medium tracking-tight transition-colors rounded-full ${
                  isActive
                    ? "text-gomill-green bg-gomill-cream"
                    : "text-gomill-text hover:text-gomill-green hover:bg-gomill-cream/60"
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-2 shrink-0">
          <Link
            to="/find"
            data-testid="nav-locate-btn"
            className="inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-gomill-mustard hover:bg-gomill-mustardDark text-gomill-green text-sm font-semibold shadow-sm transition-colors"
          >
            <MapPin className="w-4 h-4" /> Find GoMill
          </Link>
        </div>

        <button
          className="lg:hidden p-2 rounded-full bg-gomill-cream"
          onClick={() => setOpen(true)}
          aria-label="Open menu"
          data-testid="nav-mobile-open"
        >
          <Menu className="w-5 h-5 text-gomill-green" />
        </button>
      </div>
    </header>

    {open && (
      <div className="fixed inset-0 z-[100] bg-gomill-bg overflow-y-auto" data-testid="mobile-menu">
        <div className="px-5 py-5 flex items-center justify-between border-b border-gomill-border">
          <img src={BRAND.logoFull} alt="GoMill" className="h-12" />
          <button
            onClick={() => setOpen(false)}
            className="p-2 rounded-full bg-gomill-cream"
            aria-label="Close menu"
            data-testid="nav-mobile-close"
          >
            <X className="w-5 h-5 text-gomill-green" />
          </button>
        </div>
        <div className="px-5 py-6 flex flex-col gap-1">
          {NAV_LINKS.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              data-testid={`mobile-link-${link.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
              className={({ isActive }) =>
                `px-4 py-3 rounded-2xl text-lg font-medium ${
                  isActive ? "bg-gomill-green text-white" : "bg-gomill-cream text-gomill-text"
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
          <Link
            to="/find"
            className="mt-4 inline-flex justify-center items-center gap-2 px-5 py-3 rounded-full bg-gomill-mustard text-gomill-green font-semibold"
          >
            <MapPin className="w-4 h-4" /> Find GoMill
          </Link>
        </div>
      </div>
    )}
    </>
  );
}
